export default {
	export_cancel: 'Votre export est annulé.',
	export_end: 'Votre export est terminé.'
};
